import {
  FETCH_TRANSFER_LIST,
  TRANSFER_LIST_FETCHED_SUCCESS,
  TRANSFER_LIST_FETCHED_FAILED,
  TRANSFER_ACTED,
} from '../../constants/actionTypes';

const initialState = {
  transfers: [],
  pager: { current: 1, pageSize: 50, total: 0 },
  loading: false,
  filters: {},
  error: null,
};

export default function transferApproval(state = initialState, action) {
  switch (action.type) {
    case FETCH_TRANSFER_LIST:
      return {
        ...state,
        loading: true,
        error: null,
        filters: action.payload,
      };
    case TRANSFER_LIST_FETCHED_SUCCESS:
      return {
        ...state,
        loading: false,
        transfers: action.payload.transfers,
        pager: action.payload.pager,
        filters: action.payload.filters,
      };

    case TRANSFER_LIST_FETCHED_FAILED:
      return {
        ...state,
        loading: false,
        error: 'Failed to load transfers',
        filters: state.filters,
      };

    case TRANSFER_ACTED:
      // No UI update for now, but you could update the row here if you wanted
      return state;

    default:
      return state;
  }
}
